module.exports = __webpack_public_path__ + "static/hubspotTriangle-a385209afc4b303a8272b2f03deeda22.png";